import { createContext } from '../ContextSelector';
var HoverContext = createContext();
export default HoverContext;